import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { LocationsCountersHttpClient } from './locations-counters.http-client';
import { LocationCountersActions } from './locations-counters.store';

@Injectable({ providedIn: 'root' })
export class LocationsCountersEffects {
  public effects = createEffectFactory(LocationCountersActions, this.actions$);

  public fetch$ = this.effects(LocationCountersActions.fetch, () =>
    this.http.fetch().pipe(map(data => data.counters)),
  );

  constructor(
    private actions$: Actions,
    private http: LocationsCountersHttpClient,
  ) {}
}
